"use strict";
angular.module("internal.exams").controller("InternalExamViewsCriteria", ["$scope", "$stateParams", "Queries", "EXType", "EXSessionStatus", "EXLocation", "LicenseCategoryLevels", "$window", "$state",
    function ($scope, $stateParams, Queries, EXType, EXSessionStatus, EXLocation, LicenseCategoryLevels, $window, $state) {
        $scope.query = $stateParams.query;
        $scope.saving = false;
        $scope.saveMessage = $stateParams.saveMessage;
        //Initializing non-calculated values
        $scope.query.query_criteria.forEach(function (criteria) {
            (function (criteria) {
                if (criteria.query_field.component_name == "EXType") {
                    EXType.get().then(function (types) {
                        criteria.query_values = types.records;
                    });
                } else if (criteria.query_field.component_name == "EXSessionStatus") {
                    EXSessionStatus.get().then(function (sessionStatus) {
                        criteria.query_values = sessionStatus;
                    });
                } else if (criteria.query_field.component_name == "EXLocation") {
                    EXLocation.get().then(function (locations) {
                        criteria.query_values = locations.records;
                    });
                } else if (criteria.query_field.component_name == "LicenseCategoryLevels") {
                    LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (levels) {
                        criteria.query_values = [];
                        levels.forEach(function (level) {
                            criteria.query_values.push({ id: level.id, name: level.combined_name })
                        });
                    });
                }
            }(criteria));
        })

        $scope.andOrOptions = [{ name: 'And', id: true }, { name: 'Or', id: false },]

        $scope.leftParensOptions = [{ name: '(', id: 1 }, { name: '((', id: 2 },]

        Queries.getFields('581C08D3-089F-4AAF-A95A-662C48A56983').then(function (fields) {
            $scope.fields = fields;
        });
        $scope.fieldChanged = function (criteria) {
            criteria.query_calculated_value = null;
            criteria.query_calculated_values = [];
            criteria.value = null;
            criteria.query_values = [];
            criteria.query_operator = null;
            criteria.query_operators = [];
            Queries.getField(criteria.query_field.id).then(function (field) {
                criteria.query_operators = field.query_operators;
                if (field.component_name == null) {
                    criteria.query_calculated_values = field.query_calculated_values;
                } else {
                    if (field.component_name == "EXType") {
                        EXType.get().then(function (types) {
                            criteria.query_values = types.records;
                        });
                    } else if (field.component_name == "EXSessionStatus") {
                        EXSessionStatus.get().then(function (sessionStatus) {
                            criteria.query_values = sessionStatus;
                        });
                    } else if (field.component_name == "EXLocation") {
                        EXLocation.get().then(function (locations) {
                            criteria.query_values = locations.records;
                        });
                    } else if (field.component_name == "LicenseCategoryLevels") {
                        LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (levels) {
                            levels.forEach(function (level) {
                                criteria.query_values.push({ id: level.id, name: level.combined_name })
                            });
                        });
                    }
                }
            });
        }

        $scope.rightParensOptions = [{ name: ')', id: 1 }, { name: '))', id: 2 },]

        $scope.addCriteria = function () {
            $scope.query.query_criteria.push({})
        }

        $scope.saveCriteria = function () {
            $scope.saving = true;
            $scope.query.query_page_id = '581C08D3-089F-4AAF-A95A-662C48A56983'
            //Accomodate strange naming of header in [Query_Filter_Values](display_label) and [Query_Advanced_Filter_Values](label)
            $scope.query.query_filter_values.forEach(function (value) {
                value.display_label = value.name;
            })
            $scope.query.query_advanced_filter_values.forEach(function (value) {
                value.label = value.name;
            })
            var sortOrder = 1;
            $scope.query.query_criteria.forEach(function (criteria) {
                criteria.sort_order = sortOrder;
                sortOrder++;
            })
            Queries.save($scope.query).then(function (query) {
                $scope.saving = false;
                if (query != null) {
                    $state.go("internal.exams.administrative.internalview.criteria", {
                        queryId: $scope.queryId,
                        query: $scope.query,
                        saveMessage: "Record updated successfully"
                    }, {
                        reload: "internal.exams.administrative.internalview"
                    });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                    $scope.saving = false;
                }
            });
        };

        $scope.removeCriteria = function (criteria) {
            $scope.query.query_criteria.splice($scope.query.query_criteria.indexOf(criteria), 1);
        }
    }
]);